import cn from 'classnames/bind';
import {
  Container, Row, Col,
} from 'ui';

import s from './TwoColumnsForm.module.scss';

const cx = cn.bind(s);

const TwoColumnsForm = ({
  leftColumn,
  rightColumn,
  className,
}) => (
  <Container className={cx('container', className)}>
    <Row>
      <Col
        lg={{
          offset: 1,
          span: 10,
        }}
      >
        <div className={cx('content')}>
          <div className={cx('infoColumn')}>
            <div className={cx('infoWrapper')}>
              {leftColumn}
            </div>
          </div>
          <Container className={cx('formContainer')}>
            <Row>
              <Col
                xs={12}
                md={{
                  offset: 2,
                  span: 8,
                }}
                lg={{
                  offset: 0,
                  span: 12,
                }}
              >
                <div className={cx('formColumn')}>
                  <div className={cx('formWrapper')}>{rightColumn}</div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Col>
    </Row>
  </Container>
);

export default TwoColumnsForm;
